import request from '@/utils/http'

export class commonService {
  //通知列表
  static getNoticeList(params: Api.Common.PaginatingParams) {
    return request.get<Api.Common.CommonListData>({
      url: '/common/notice/list',
      params
    })
  }
  //通知详情
  static getNoticeDetail(params: any) {
    return request.get<Api.Common.CommonListData>({
      url: '/common/notice/show',
      params
    })
  }
  //通知已读
  static readNotice(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/common/notice/read',
      params
    })
  }
  //通知删除
  static delNotice(params: any) {
    return request.post<Api.Common.AddResponse>({
      url: '/common/notice/destroy',
      params
    })
  }
  //通知未读列表
  static getUnReadNoticeList() {
    return request.get<any>({
      url: '/common/notice/unread'
    })
  }
  //账户下拉框
  static getAccountSelect() {
    return request.get<any>({
      url: '/common/preset/account'
    })
  }
  //名下客户下拉框
  static getCustomerSelect() {
    return request.get<any>({
      url: '/crm/customer/preset'
    })
  }
  //角色下拉框
  static getRoleSelect() {
    return request.get<any>({
      url: '/common/preset/roles'
    })
  }
  //用户下拉框
  static getUserSelect() {
    return request.get<any>({
      url: '/common/preset/users'
    })
  }
  //分类下拉
  static getClassifySelect() {
    return request.get<any>({
      url: '/common/nav/categories/preset'
    })
  }
  //签名 编辑
  static signatureEdit(params: any) {
    return request.post<any>({
      url: '/admin/user/update/sign',
      params
    })
  }
  //获取设置
  static getSetting(params: any) {
    return request.get<any>({
      url: '/common/config/find',
      params: params
    })
  }
}
